module.exports = __webpack_public_path__ + "img/bird-blue.8d2f9797.svg";